export default __webpack_public_path__ + "static/media/googleads.7fb5812d.png";